if (!customElements.get('ja-responsive-video')) {
    customElements.define('ja-responsive-video', class extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('deferred-media');
        this.playerTemplate = this.media?.querySelector('template');
        if (!this.playerTemplate) return;
        this.mobileQuery = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
        this.updatePlayer = this.updatePlayer.bind(this);
        this.mobileQuery.addEventListener('change', this.updatePlayer);
        this.updatePlayer();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.updatePlayer);
      }

      updatePlayer() {
        if (this.mobileQuery.matches) {
          if (this.media.hasAttribute('data-mobile-player')) return;
          const player = this.playerTemplate.content.querySelector('iframe').cloneNode(true);
          const source = new URL(player.src);
          source.searchParams.set('autoplay', '0');
          player.src = source.toString();
          player.loading = 'lazy';
          this.media.querySelector(':scope > iframe')?.remove();
          this.media.appendChild(player);
          this.media.setAttribute('loaded', 'true');
          this.media.setAttribute('data-mobile-player', '');
        } else if (this.media.hasAttribute('data-mobile-player')) {
          this.media.querySelector(':scope > iframe')?.remove();
          this.media.removeAttribute('loaded');
          this.media.removeAttribute('data-mobile-player');
        }
      }
    });
  }
